// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"0ab547e5","295":"ac95dcc8","614":"a3befa44","831":"ac95dcc8"}[chunkId] + ".chunk.css";
};